import type { MutuallyExclusive } from '@eti/schema-types';
import type { AvailableExtraProductsOnTdPageFragmentType } from '../../../common/types/fragments/models';

export type PurchasableMuxProductType = {
  availableExtraProducts: AvailableExtraProductsOnTdPageFragmentType;
  mutuallyExclusiveProducts: (MutuallyExclusive | null)[];
};

export const getPurchasableMuxProducts = ({
  availableExtraProducts,
  mutuallyExclusiveProducts,
}: PurchasableMuxProductType) => {
  const targetProductIdList: MutuallyExclusive['productTypes'] | [] =
    mutuallyExclusiveProducts[0]?.productTypes || [];
  return (
    availableExtraProducts?.filter(
      (product) =>
        targetProductIdList?.some(
          (targetedProductId: number | null) => String(product?.id) === String(targetedProductId),
        ),
    ) || []
  );
};
